import React from "react";

export default function Acheivement() {
  return <div>Coming soon...</div>;
}
